//sticky cart click
document.addEventListener("DOMContentLoaded", () => {
const items = document.querySelector(".header__inline-menu").querySelectorAll("details");

items.forEach(item => {
item.addEventListener("mouseover", () => {
item.setAttribute("open", true);
});

item.addEventListener("mouseleave", () => {
setTimeout(() => {
if (!item.matches(":hover") && !item.querySelector("ul").matches(":hover")) {
item.removeAttribute("open");
}
}, 200); 
});

item.querySelector("ul").addEventListener("mouseleave", () => {
setTimeout(() => {
if (!item.matches(":hover") && !item.querySelector("ul").matches(":hover")) {
item.removeAttribute("open");
}
}, 200); 
});
});
});
$(window).on('scroll', function() {
    // Get the current scroll position
    var scrollPosition = $(window).scrollTop();
    
    var sectionEnd = $('.custom__main-pdp').offset().top + $('.custom__main-pdp').outerHeight();
    if (scrollPosition >= sectionEnd) {
        // Show sticky bar
        $('#sticky_cart').fadeIn();
    } else {
        // Hide sticky bar when in the `.custom__main-pdp` section
        $('#sticky_cart').fadeOut();
    }
});

$("document").ready(function () {

    function Default_templatejs() {
    var custom_val1 = $(".custom__varr--1 input:checked").val();
    var custom_val2 = $(".custom__varr--2 input:checked").val();
    var finalop = "";
    if (custom_val1) {
      finalop += custom_val1;
    }
    if (custom_val2) {
      finalop += (finalop ? " / " : "") + custom_val2;
    }

    $(".custom__combo-variant option").removeAttr("selected");
    var comoboo_cst_mm = $(".custom__combo-variant option")
      .map(function () {
        if ($(this).attr("data-option")) return $(this).attr("data-option");
      })
      .get();

    if (jQuery.inArray(finalop.toString(), comoboo_cst_mm) >= 0) {
      $('.custom__combo-variant option[data-option="' + finalop + '"]').attr(
        "selected",
        "selected"
      );
      var selected_product_id = $(".custom__combo-variant")
        .find(":selected")
        .val();
 $(".custom__addtocart").attr("data-id",selected_product_id);
 var selected_product_price = $(".custom__combo-variant")
        .find(":selected")
        .attr("variant-data-price");
$(".custom__pdp-price").find("span.price-item.price-item--regular").html(selected_product_price);
    }
  }

Default_templatejs();

  
$(document).on("click", ".custom__variants-label", function() {
   setTimeout(function () {
Default_templatejs();
   },900);
});

  
  $(document).on("click", ".custom__addtocart", function () {
    // $(".product-form__submit").trigger("click");
var pdp_id = $(this).attr("data-id");
var quant = $(".custom__quantity.quantity__input").val();
    var items = {
      quantity: quant,
      id: pdp_id,
    };
    $.ajax({
      method: "POST",
      dataType: "json",
      contentType: "application/json",
      url: "/cart/add.js",
      data: JSON.stringify(items),
      success: function (response) {
        $("cart-drawer").load(location.href + " #CartDrawer");
        $("#cart-icon-bubble").load(location.href + " #cart-icon-bubble");
        setTimeout(function () {
          $("cart-drawer.drawer").removeClass("is-empty");
          $("cart-drawer.drawer").addClass("active");
        }, 1500);
      },

      error: function (response) {
      },
    });
    
  });

  // frequently bought together
  let selectedProductIds = [];

  $(".custom_product-grid").each(function () {
    const productId = $(this).attr("data-var-id");
    selectedProductIds.push(productId);
  });
  $("body").on("click", ".custom__addcart", function () {
    var items = {
      quantity: 1,
      id: selectedProductIds,
    };
    $.ajax({
      method: "POST",
      dataType: "json",
      contentType: "application/json",
      url: "/cart/add.js",
      data: JSON.stringify(items),
      success: function (response) {
        $("cart-drawer").load(location.href + " #CartDrawer");
        $("#cart-icon-bubble").load(location.href + " #cart-icon-bubble");
        setTimeout(function () {
          $("cart-drawer.drawer").removeClass("is-empty");
          $("cart-drawer.drawer").addClass("active");
        }, 1500);
      },

      error: function (response) {
       },
    });
  });
  // buy now button
  $("body").on("click", ".custom__buycart", function () {
    var items = {
      quantity: 1,
      id: selectedProductIds,
    };
    $.ajax({
      method: "POST",
      dataType: "json",
      contentType: "application/json",
      url: "/cart/add.js",
      data: JSON.stringify(items),
      success: function (response) {
         window.location.href = "/checkout";
      },
      error: function (response) {
      },
    });
  });

$('.custom-video').click(function() {
    var deferredMediaContainer = $(this).closest('deferred-media');
    var video = deferredMediaContainer.find('video')[0] || (function() {
        var template = deferredMediaContainer.find('template');
        deferredMediaContainer.append(template.html());
        template.remove();
        return deferredMediaContainer.find('video')[0];
    })();
    $('deferred-media').not(deferredMediaContainer).find('video').each(function() {
        this.pause();
        $(this).closest('deferred-media').find('.icon-pause').hide();
        $(this).closest('deferred-media').find('.icon-play').show();
    });
   if (video) {
        if (video.paused) {
            video.play();
            deferredMediaContainer.find('.icon-pause').show();
            deferredMediaContainer.find('.icon-play').hide();
        } else {
            video.pause();
            deferredMediaContainer.find('.icon-play').show();
            deferredMediaContainer.find('.icon-pause').hide();
        }
    }
});
});
